export default __webpack_public_path__ + "ec2ce4f2e74dd353d663f1e150afe4a7.svg";